module.exports = __webpack_public_path__ + "static/media/MHei-Medium.ca536a9d.svg";